/**
 * Cams API
 * Cams
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface MSP15InputContentDTO { 
    sno?: string | null;
    branchName?: string | null;
    region?: string | null;
    district?: string | null;
    localGovernment?: string | null;
    ward?: string | null;
    village?: string | null;
    numberofEmployees?: string | null;
    yearEstablished?: string | null;
}

